import {SupportedValue} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {IReport} from '../ReportGenerator/types';

export const filterReportsByUserAndForms = (
    reports: IReport[],
    users: SupportedValue[],
    forms: SupportedValue[]
) => {
    return reports.filter(
        report =>
            (users.length ? users.includes(report.userName) : true) &&
            (forms.length ? forms.includes(report.baseForm || '') : true)
    );
};
